import { PageTypeEnum } from '@/constant';
import {
	CommonActions,
	CommonSelectors,
	useAppSelector,
	WorkerApplicantActions,
	WorkerFranchiseActions,
} from '@/stores';
import { NOOP, showAlert } from '@/utils';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { IProps } from './app-use-info-popup.type';

export const useLogic = (props: IProps) => {
	const { onCancel, fullName, refTableName } = props;

	const { id } = useParams();
	const { t } = useTranslation('common');
	const dispatch = useDispatch();

	const [tooltipVisible, setTooltipVisible] = useState(false);

	const appUserInfo = useAppSelector(CommonSelectors.selectAppUserInfo);
	const fetchingGetAppUserInfo = useAppSelector(
		CommonSelectors.selectFetchingGetAppUserInfo
	);

	const onSaveClick = useCallback(() => {
		onCancel();
	}, [onCancel]);

	const handleResetPassword = useCallback(() => {
		dispatch(
			CommonActions.resetPasswordRequest({
				id: Number(appUserInfo?.id),
				callback: (error: any) => {
					if (error) {
						return;
					}
					showAlert('비밀번호가 변경되었습니다.');
				},
			})
		);
	}, [appUserInfo?.id]);

	const handleUnWithdrawn = useCallback(() => {
		dispatch(
			CommonActions.unWithdrawnRequest({
				id: Number(appUserInfo?.id),
				callback: (error: any) => {
					if (error) {
						return;
					}
					showAlert('탈퇴가 취소되었습니다.');

					dispatch(
						CommonActions.getAppUserInfoRequest({
							id: Number(id),
							type: refTableName,
						})
					);
					if (refTableName === PageTypeEnum.APPLICANT) {
						dispatch(
							WorkerApplicantActions.getWorkerApplicantDetailRequest({
								id: Number(id),
							})
						);
					}

					if (refTableName === PageTypeEnum.FRANCHISE) {
						dispatch(
							WorkerFranchiseActions.getWorkerFranchiseDetailRequest({
								id: Number(id),
							})
						);
					}
				},
			})
		);
	}, [appUserInfo?.id]);

	const onResetPassword = useCallback(() => {
		showAlert(
			`${fullName} 비밀번호가 생년월일로 변경됩니다.`,
			handleResetPassword,
			NOOP
		);
	}, [handleResetPassword, fullName]);

	useEffect(() => {
		if (id) {
			dispatch(
				CommonActions.getAppUserInfoRequest({
					id: Number(id),
					type: refTableName,
				})
			);
		}
	}, [id]);

	return {
		t,
		appUserInfo,
		fetchingGetAppUserInfo,

		onSaveClick,
		onResetPassword,
		handleUnWithdrawn,

		tooltipVisible,
		setTooltipVisible,
	};
};
